import { useParams } from 'react-router-dom';

import { ProfileAboutContainer } from '@containers/ProfileAbout';

import s from './ProfileAboutPage.sss';

type Params = {
  username?: string
};

export const ProfileAboutPage: React.FC = () => {
  const { username } = useParams<Params>();

  if (!username) {
    throw new Error('No username in params');
  }

  return (
    <div className={s.root}>
      <ProfileAboutContainer username={username} />
    </div>
  );
};

export default ProfileAboutPage;
